import styles from "./Services.module.css";
import { services } from "../../data/services";
import { ServiceCard } from "./ServiceCard";

export function Services() {
  return (
    <section id="services" className={styles.section} aria-labelledby="services-heading">
      <div className="container">
        <div className={styles.head}>
          <span className="eyebrow">What We Do</span>
          <h2 id="services-heading">Visibility That Goes Beyond the Screen.</h2>
          <p>
            From outdoor campaigns to everyday brand presence, we create physical touchpoints
            that get noticed.
          </p>
        </div>

        <div className={styles.grid}>
          {services.map((service, i) => (
            <ServiceCard key={service.id} service={service} delay={(i % 3) * 60} />
          ))}
        </div>
      </div>
    </section>
  );
}
